import { Component, OnInit } from '@angular/core';
import { CustomerService } from '../../services/customer.service';
import { Customer } from '../../models/customer';

@Component({
  selector: 'app-add-customer',
  templateUrl: './add-customer.component.html',
  styleUrls: ['./add-customer.component.css']
})


export class AddCustomerComponent implements OnInit {
  customer: Customer = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '' // WHY DOESNT THIS WORK with number assignment: SEE CUSTOMER MODEL
  }

  constructor(private customerService: CustomerService) { }

  ngOnInit() {
  }

  // submit form to add customer
  onSubmit() {
    if (this.customer.firstName !== '' && this.customer.lastName !== '' && this.customer.email !== '' && this.customer.phoneNumber !== '') {
        this.customerService.addCustomer(this.customer);
        // clear input fields
        this.customer.firstName = '';
        this.customer.lastName = '';
        this.customer.email = '';
        this.customer.phoneNumber = ''; // WHYYY NO WORK with number assignment: SEE CUSTOMER MODEL
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/add-customer/add-customer.component.ts